module.exports = __webpack_public_path__ + "static/img/fefco427_1.519ca48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco427_1.png
// module id = e0lH
// module chunks = 0